<template>
  <div class="container">
    <v-card>
      <v-card-title class="text-h4">Ρυθμίσεις Primer</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container>
          <!-- Alert Messages -->
          <v-alert
            v-if="successMessage"
            type="success"
            dismissible
            @input="successMessage = null"
            class="mb-4"
          >
            {{ successMessage }}
          </v-alert>

          <v-alert
            v-if="errorMessage"
            type="error"
            dismissible
            @input="errorMessage = null"
            class="mb-4"
          >
            {{ errorMessage }}
          </v-alert>

          <!-- Form Section -->
          <v-form @submit.prevent="savePrimerCredentials" autocomplete="off">
            <v-row>
              <v-col cols="12" md="6">

              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.primer_username"
                  label="Όνομα χρήστη Primer"
                  outlined
                  required
                  type="text"
                  name="primer-user"
                  autocomplete="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="text"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-lpignore="true"
                ></v-text-field>
                <v-text-field
                  v-model="formData.primer_password"
                  label="Κωδικός Primer"
                  type="text"
                  outlined
                  required
                  name="primer-pass"
                  autocomplete="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="text"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-lpignore="true"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.primer_serial_number"
                  label="Σειριακός Αριθμός Connector"
                  outlined
                  required
                  type="text"
                  name="primer-serial"
                  autocomplete="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="text"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-lpignore="true"
                ></v-text-field>
                
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>
            <v-subheader class="pl-0">Στοιχεία Εκπροσώπου</v-subheader>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.representative_first_name"
                  label="Όνομα Εκπροσώπου"
                  outlined
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.representative_last_name"
                  label="Επώνυμο Εκπροσώπου"
                  outlined
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.representative_afm"
                  label="ΑΦΜ Εκπροσώπου"
                  outlined
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="my-4"></v-divider>
            <v-subheader class="pl-0">Στοιχεία SIM</v-subheader>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.sim_contract_id"
                  label="Αριθμός Σύμβασης SIM"
                  outlined
                  type="text"
                  name="sim-contract-id"
                  autocomplete="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="text"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-lpignore="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.sim_provider_name"
                  label="Πάροχος SIM"
                  outlined
                  type="text"
                  name="sim-provider-name"
                  autocomplete="off"
                  autocapitalize="none"
                  spellcheck="false"
                  inputmode="text"
                  data-1p-ignore="true"
                  data-bwignore="true"
                  data-lpignore="true"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="datePickerMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatDate(formData.sim_contract_date)"
                      label="Ημερομηνία Σύμβασης SIM"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      @click:clear="formData.sim_contract_date = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :value="formData.sim_contract_date"
                    @input="formData.sim_contract_date = $event; datePickerMenu = false"
                    locale="el"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-btn color="primary" type="submit" :loading="savingCredentials">
                  <v-icon left>mdi-content-save</v-icon>
                  Αποθήκευση Στοιχείων
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <v-divider class="my-6"></v-divider>

          <!-- Action Buttons Section -->
          <v-subheader class="pl-0 text-h6">Ενέργειες Primer</v-subheader>

          <v-row class="mt-4">
            <v-col cols="12" md="6" lg="4">
              <v-btn
                block
                color="info"
                :loading="registerLoading"
                @click="registerCompany"
                :disabled="!canExecuteActions"
              >
                <v-icon left>mdi-plus-circle</v-icon>
                Εγγραφή Εταιρίας
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <v-btn
                block
                color="warning"
                :loading="updateLoading"
                @click="updateCompany"
                :disabled="!canExecuteActions"
              >
                <v-icon left>mdi-pencil-circle</v-icon>
                Ενημέρωση Εταιρίας
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <v-btn
                block
                color="success"
                :loading="activateLoading"
                @click="activateProduct"
                :disabled="!canExecuteActions"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Ενεργοποίηση Προϊόντος
              </v-btn>
            </v-col>
          </v-row>

          <!-- Loading Progress -->
          <v-progress-linear
            v-if="showProgress"
            indeterminate
            class="mt-4"
          ></v-progress-linear>

          <!-- Response Details -->
          <v-card v-if="responseData" class="mt-6" outlined>
            <v-card-title class="text-h6">Αποτέλεσμα Αίτησης</v-card-title>
            <v-card-text>
              <pre class="font-monospace">{{ JSON.stringify(responseData, null, 2) }}</pre>
            </v-card-text>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    datePickerMenu: false,
    formData: {
      primer_serial_number: '',
      primer_username: '',
      primer_password: '',
      representative_first_name: '',
      representative_last_name: '',
      representative_afm: '',
      sim_contract_id: '',
      sim_provider_name: '',
      sim_contract_date: null,
    },
    successMessage: null,
    errorMessage: null,
    savingCredentials: false,
    registerLoading: false,
    updateLoading: false,
    activateLoading: false,
    showProgress: false,
    responseData: null,
  }),

  computed: {
    canExecuteActions() {
      return (
        this.formData.primer_serial_number &&
        this.formData.primer_username &&
        this.formData.primer_password
      );
    },
  },

  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      // dateStr is in YYYY-MM-DD format from database/picker
      const parts = dateStr.split('-');
      if (parts.length !== 3) return dateStr;
      return `${parts[2]}/${parts[1]}/${parts[0]}`; // DD/MM/YYYY for display
    },

    async loadCompanyData() {
      try {
        const response = await axios.get('/api/company');
        const company = response.data;
        
        this.formData = {
          primer_serial_number: company.primer_serial_number || '',
          primer_username: company.primer_username || '',
          primer_password: company.primer_password || '',
          representative_first_name: company.representative_first_name || '',
          representative_last_name: company.representative_last_name || '',
          representative_afm: company.representative_afm || '',
          sim_contract_id: company.sim_contract_id || '',
          sim_provider_name: company.sim_provider_name || '',
          sim_contract_date: company.sim_contract_date || null,
        };
      } catch (error) {
        this.errorMessage = 'Σφάλμα κατά τη φόρτωση των στοιχείων: ' + (error.response?.data?.message || error.message);
      }
    },

    async savePrimerCredentials() {
      this.savingCredentials = true;
      this.successMessage = null;
      this.errorMessage = null;

      try {
        const response = await axios.post('/api/primer/update-credentials', this.formData);
        this.successMessage = 'Τα στοιχεία ενημερώθηκαν με επιτυχία';
      } catch (error) {
        this.errorMessage = 'Σφάλμα κατά την αποθήκευση: ' + (error.response?.data?.message || error.message);
      } finally {
        this.savingCredentials = false;
      }
    },

    async registerCompany() {
      this.registerLoading = true;
      this.successMessage = null;
      this.errorMessage = null;
      this.responseData = null;

      try {
        const response = await axios.post('/api/primer/register-company');
        this.responseData = response.data;
        this.successMessage = 'Η εγγραφή της εταιρίας ολοκληρώθηκε με επιτυχία';
      } catch (error) {
        this.responseData = error.response?.data;
        this.errorMessage = 'Σφάλμα κατά την εγγραφή της εταιρίας: ' + (error.response?.data?.message || error.message);
      } finally {
        this.registerLoading = false;
      }
    },

    async updateCompany() {
      this.updateLoading = true;
      this.successMessage = null;
      this.errorMessage = null;
      this.responseData = null;

      try {
        const response = await axios.post('/api/primer/update-company');
        this.responseData = response.data;
        this.successMessage = 'Η ενημέρωση της εταιρίας ολοκληρώθηκε με επιτυχία';
      } catch (error) {
        this.responseData = error.response?.data;
        this.errorMessage = 'Σφάλμα κατά την ενημέρωση της εταιρίας: ' + (error.response?.data?.message || error.message);
      } finally {
        this.updateLoading = false;
      }
    },

    async activateProduct() {
      this.activateLoading = true;
      this.successMessage = null;
      this.errorMessage = null;
      this.responseData = null;

      try {
        const response = await axios.post('/api/primer/activate-product');
        this.responseData = response.data;
        this.successMessage = 'Η ενεργοποίηση του προϊόντος ολοκληρώθηκε με επιτυχία';
      } catch (error) {
        this.responseData = error.response?.data;
        this.errorMessage = 'Σφάλμα κατά την ενεργοποίηση του προϊόντος: ' + (error.response?.data?.message || error.message);
      } finally {
        this.activateLoading = false;
      }
    },
  },

  mounted() {
    this.loadCompanyData();
  },
};
</script>

<style scoped>
.font-monospace {
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  max-height: 400px;
  overflow-y: auto;
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
}
</style>
